<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { formatSoftBreaks } from 'shared/helpers/formatSoftBreaks.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
  spacedLineBreaks: {
    type: Boolean,
    default: false,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  const formattedMessage = new MessageFormatter(props.content).formattedMessage;

  return props.spacedLineBreaks
    ? formatSoftBreaks(formattedMessage)
    : formattedMessage;
});
</script>

<template>
  <div
    v-dompurify-html="formattedContent"
    class="prose prose-bubble min-w-0 max-w-full overflow-x-auto break-words [&_blockquote]:my-2 [&_code]:!bg-n-alpha-black2 [&_code]:break-words [&_li::marker]:text-current [&_li>p]:m-0 [&_ol]:my-2 [&_pre]:!bg-n-alpha-black2 [&_pre]:max-w-full [&_pre]:overflow-x-auto [&_pre_code]:!bg-transparent [&_pre_code]:!p-0 [&_table]:my-2 [&_table]:w-full [&_table]:table-fixed [&_table]:border-collapse [&_table]:text-xs [&_td]:break-words [&_td]:whitespace-normal [&_td]:align-top [&_td]:border [&_td]:border-n-weak [&_td]:px-2 [&_td]:py-1.5 [&_th]:break-words [&_th]:whitespace-normal [&_th]:align-top [&_th]:border [&_th]:border-n-weak [&_th]:bg-n-alpha-2 [&_th]:px-2 [&_th]:py-1.5 [&_th]:font-semibold [&_ul]:my-2"
  />
</template>
